/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./totop.vue?vue&type=template&id=3fc2a9b4&scoped=true&"
import script from "./totop.vue?vue&type=script&lang=js&"
export * from "./totop.vue?vue&type=script&lang=js&"
import style0 from "./totop.vue?vue&type=style&index=0&id=3fc2a9b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2a9b4",
  null
  
)

export default component.exports